/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { ReputationActionTaken } from '../enums/reputation-action-taken';
import { CandidateEntity } from './candidate-entity';
import { OpportunityEntity } from './opportunity-entity';
import { TopTaskEntity } from './top-task-entity';
export class CandidateReputationDetailEntity extends Entity {
  actionNotes: string | null = null;
  actionTaken: ReputationActionTaken | null = null;
  actionTakenAt: string | null = null;
  actionTakenHistory: Record<string, unknown> | null = null;
  axiomClientRecommendScore: number | null = null;
  axiomDidWellOn: string | null = null;
  axiomImproveOn: string | null = null;
  businessJudgementScore: number | null = null;
  candidate: CandidateEntity | null = null;
  candidateId: string = '';
  clientRecommendScore: number | null = null;
  communicationScore: number | null = null;
  createdAt: string | null = null;
  didWellOn: string | null = null;
  historical: boolean = false;
  id: string = '';
  improveOn: string | null = null;
  inTopTenPercent: boolean | null = null;
  legalExpertiseScore: number | null = null;
  matterId: string | null = null;
  meetsExpectations: boolean | null = null;
  opportunity: OpportunityEntity | null = null;
  opportunityId: string = '';
  respondentName: string | null = null;
  responseDate: string | null = null;
  responseId: string | null = null;
  responsivenessScore: number | null = null;
  retiredDidWellOnImproveOn: string | null = null;
  topTask: TopTaskEntity | null = null;
  topTaskId: string | null = null;
  updatedAt: string | null = null;
  static override key = 'CandidateReputationDetail';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      opportunity: OpportunityEntity,
      topTask: TopTaskEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateReputationDetail' in input
    ) {
      const { CandidateReputationDetail: wrapped, ...rest } = input as {
        CandidateReputationDetail: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}